var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"base-icon icon-less",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M64 27v10H0V27h64Z","clip-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }